abstract class Type {

  public getValue(): number {
    return Object.getPrototypeOf(this).constructor.contactForContractTypeId;
  }

  public isSelectable(): boolean {
    return Object.getPrototypeOf(this).constructor.selectable;
  }
}

export { Type }
